export const debtIndexNames: Record<string, string> = {
  "^ESTR": "ESTR",
  "^SOFR": "SOFR",
  "^SONIA": "SONIA",
  "^EURIBOR1M": "EURIBOR 1M",
  "^200010": "200010",
  "^120010": "120010",
  "^CPI": "linkage.consumerPriceIndex",
  PRIME_RATE: "linkage.primeRate"
};

// Hard coded - same constant in the backend
export const DEBT_MEASURE_ROLES = {
  principal: "1",
  interest: "2",
  principalPrepayment: "3",
  principalRefinance: "4",
  vat: "5",
  callProtectionFee: "6",
  fixedFee: "7",
  yieldMaintenanceFee: "8",
  creditFacilityFee: "9",
  disbursement: "10"
};

export const DEBT_MEASURE_FETCHABLE_NAME = "debt-measures";

export enum PaymentStatus {
  RESOLVED = "resolved",
  MISMATCH = "mismatch"
}